import { ImgHTMLAttributes } from "react";
import banner from "@/assets/banner.svg";

/**
 * The Fairfleet banner.
 */
export function Banner(props: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <a href="https://fairfleet.de" target="_blank" rel="noopener noreferrer">
        <img {...props} src={banner} alt="FairFleet" />
      </a>
  )
}
